import type { Branded } from '@moment/utility-types'

import { z } from 'zod'

// Uppercase only: the optimizer's tradable-instrument contract rejects lowercase.
const ISIN_PATTERN = /^[A-Z]{2}[A-Z0-9]{9}[0-9]$/

/** A 12-character ISIN: country code, nine alphanumerics, check digit (shape only). */
export type IsinStr = Branded<string, 'IsinStr'>

export const IsinStr = z
  .string()
  .regex(ISIN_PATTERN)
  .transform((v): IsinStr => v as IsinStr)
